module.exports = function(app) {
    app.directive('claimInfo', function() {

        return {
            restrict: 'A',
            replace: true,

            templateUrl: 'claims.appTemplate.html/chmhom/directives/claimInfo'
        };
    });
};